import { useNavigation as useRNNavigation } from '@react-navigation/native'

/* Simply a wrapper around react navigation's hook to add types */

const useNavigation = () => useRNNavigation<NavigationProps>()
export default useNavigation
